import React, { useState } from 'react';
import { Dialog } from 'primereact/dialog';

/** Thumbnail beside a URL input, with a full size preview and a remove action. */
const GroupImageField = ({ label = 'Group Image', value, onChange }) => {
    const url = (value || '').trim();
    // Remember which URL failed so editing the URL clears the error without an effect.
    const [failedUrl, setFailedUrl] = useState(null);
    const [previewVisible, setPreviewVisible] = useState(false);
    const failed = url !== '' && failedUrl === url;
    const canPreview = url !== '' && !failed;

    return (
        <div className="form-control w-full space-y-1 mb-4">
            <label className="label py-1">
                <span className="label-text text-xs font-bold text-slate-700">{label}</span>
            </label>

            <div className="flex items-start gap-3">
                <div
                    className="shrink-0 rounded-xl border border-slate-300 bg-slate-50 overflow-hidden flex items-center justify-center text-slate-400"
                    style={{ width: '6rem', height: '6rem' }}
                >
                    {canPreview ? (
                        <img
                            src={url}
                            alt="Group banner thumbnail"
                            className="w-full h-full object-cover"
                            onError={() => setFailedUrl(url)}
                        />
                    ) : (
                        <i className={`pi ${failed ? 'pi-exclamation-triangle' : 'pi-image'} text-2xl`}></i>
                    )}
                </div>

                <div className="flex flex-col gap-1 flex-1 min-w-0">
                    <input
                        type="text"
                        className="input input-bordered w-full rounded-xl bg-white border-slate-300 text-sm"
                        placeholder="Paste image url"
                        value={value}
                        onChange={(e) => onChange(e.target.value)}
                    />
                    <span className={`text-xs ${failed ? 'text-error' : 'text-slate-500'}`}>
                        {failed ? 'Image could not be loaded' : 'Paste a link to a banner image'}
                    </span>
                    <div className="flex gap-2">
                        <button type="button" className="btn btn-xs btn-outline rounded-full" disabled={!canPreview}
                            onClick={() => setPreviewVisible(true)}>
                            <i className="pi pi-search-plus"></i> Preview full size
                        </button>
                        <button type="button" className="btn btn-xs btn-ghost text-error rounded-full" disabled={!value}
                            onClick={() => onChange('')}>
                            <i className="pi pi-trash"></i> Remove
                        </button>
                    </div>
                </div>
            </div>

            <Dialog header="Group Image" visible={previewVisible} style={{ width: '60vw' }}
                breakpoints={{ '960px': '95vw' }} onHide={() => setPreviewVisible(false)} dismissableMask>
                <img src={url} alt="Group banner" className="w-full h-auto rounded-lg" />
            </Dialog>
        </div>
    );
};

export default GroupImageField;
